import { useEffect } from 'react'
import { SocialEmbedCard } from 'components/card/SocialEmbedCard/social-embed-card'

interface TikTokCardProps {
  embedCode: string
  url: string
}

const TikTokCard = ({ embedCode, url }: TikTokCardProps) => {
  const platform = 'tiktok'
  useEffect(() => {
    const existingElement = document.getElementById('bl-tiktok')
    let script: HTMLScriptElement

    if (!existingElement) {
      script = document.createElement('script')
      script.src = 'https://www.tiktok.com/embed.js'
      script.async = true
      script.id = 'bl-tiktok'
      document.body.appendChild(script)
    }

    return () => {
      if (script) {
        document.body.removeChild(script)
      }
    }
  }, [])
  return <SocialEmbedCard embedCode={embedCode} platform={platform} url={url} />
}

export default TikTokCard
